import { Button, type ButtonProps } from '@time-line/components/common';
import { useWindowScroll } from 'react-use';
import { scrollToElement } from 'utils/utils';

const DEFAULT_TEXT = 'Shop Now';

interface AnchorButtonProps extends ButtonProps {
  anchorId: string;
}

export const AnchorButton = ({
  anchorId,
  children,
  ...props
}: AnchorButtonProps) => {
  const { y } = useWindowScroll();
  return (
    <Button
      className="button--anchor"
      onClick={() => {
        scrollToElement({
          id: anchorId,
          scrollYPos: y,
        });
      }}
      {...props}
    >
      {children ?? DEFAULT_TEXT}
    </Button>
  );
};
